/* eslint-disable no-param-reassign */
import { combineReducers } from 'redux'
import { reducer as reduxFormReducer } from 'redux-form'

import { facilitySlice } from '../store/facility'
import { providersSlice } from '../store/providers'
import { specialtiesSlice } from '../store/specialties'
import extendReferralReducer, {
  ExtendReferralState,
} from './reducer.extendReferral'
import resetPasswordReducer from './reducer.forgetPassword'
import memberDetailReducer from './reducer.memberDetail'
import memberSearchReducer from './reducer.memberSearch'
import planDetailReducer from './reducer.planDetail'
import practiceProfileReducer from './reducer.practiceProfile'
import practiceReportReducer from './reducer.practiceReports'
import providerDetailsReducer from './reducer.providerDetails'
import providerSelectedReducer from './reducer.providerSelected'
import referralManagementReducer from './reducer.referralManagement'
import referralProviderReducer from './reducer.referralProvider'
import selectedMemberReducer from './reducer.selectedMember'
import signInUserReducer from './reducer.signInUser'
import ssoLoginReducer from './reducer.ssoLogin'
import submitReferralReducer from './reducer.submitReferral'
import serverErrorReducer from './reuder.common'
import getReferralMemberReducer, {
  GetReferralMemberState,
} from './reducer.getReferralMember'

export interface RootState {
  form: any
  memberSearch: any
  memberDetail: any
  selectedMember: any
  providerSelected: any
  referralProvider: any
  referralManagement: any
  submitReferralProvider: any
  extendReferral: ExtendReferralState
  providerDetails: any
  signInUser: any
  ssoLogin: any
  planDetail: any
  server: any
  resetPassword: any
  header?: any
  practiceProfile: any
  practiceReports: any
  facilities: any
  specialties: any
  providers: any
  getReferralMember: GetReferralMemberState
}

const rootReducer = combineReducers({
  form: reduxFormReducer,
  memberSearch: memberSearchReducer,
  memberDetail: memberDetailReducer,
  selectedMember: selectedMemberReducer,
  providerSelected: providerSelectedReducer,
  referralProvider: referralProviderReducer,
  referralManagement: referralManagementReducer,
  submitReferralProvider: submitReferralReducer,
  extendReferral: extendReferralReducer,
  providerDetails: providerDetailsReducer,
  signInUser: signInUserReducer,
  ssoLogin: ssoLoginReducer,
  planDetail: planDetailReducer,
  server: serverErrorReducer,
  resetPassword: resetPasswordReducer,
  practiceProfile: practiceProfileReducer,
  practiceReports: practiceReportReducer,
  facilities: facilitySlice.reducer,
  specialties: specialtiesSlice.reducer,
  providers: providersSlice.reducer,
  getReferralMember: getReferralMemberReducer,
})

export const reducers = (state: any, action: any) => {
  if (action.type === 'RESET') {
    state = undefined
  }

  if (action.type === 'RESET_TO') {
    state = action.payload
  }

  return rootReducer(state, action)
}
